import { FILES } from "i18n/constants";
import { useTranslations } from "i18n";
import React from "react";
import {
  AvailibilityRedirectCardButton,
  AvailibilityRedirectCardContainer,
  AvailibilityRedirectCardContent,
  AvailibilityRedirectCardText
} from "./styles";

const AvailibilityRedirectCard: React.FC = () => {
  const t = useTranslations(FILES.CONVERTER);

  return (
    <AvailibilityRedirectCardContainer>
      <AvailibilityRedirectCardContent>
        <AvailibilityRedirectCardText as="h2" size="xl" marketing>
          {t("availabilityCardTitle")}
        </AvailibilityRedirectCardText>
        <AvailibilityRedirectCardButton
          size="md"
          href={"https://www.gemini.com/areas-of-availability"}
          target="_blank"
        >
          {t("seeWhere")}
        </AvailibilityRedirectCardButton>
      </AvailibilityRedirectCardContent>
    </AvailibilityRedirectCardContainer>
  );
};

export default AvailibilityRedirectCard;
